'use client';

import {useTranslations} from 'next-intl';
import {Radio} from '../../../../../components/design-system';
import FilterSection from './FilterSection';
import useFilters from './hooks/useFilters';

function FilterSectionSort() {
  const t = useTranslations('shop');

  const {filters, set} = useFilters();

  function handleChange(
    sort:
      | 'rank:asc'
      | 'rank:desc'
      | 'name:asc'
      | 'name:desc'
      | 'price:asc'
      | 'price:desc',
  ) {
    set({sort});
  }

  return (
    <FilterSection title={t('filter.sort.title')}>
      <div className="space-y-2">
        <Radio
          name="sort"
          onChange={handleChange}
          selectedValue={filters.sort}
          value="rank:asc"
          label={t('filter.sort.rankAsc')}
        />
        <Radio
          name="sort"
          onChange={handleChange}
          selectedValue={filters.sort}
          value="name:asc"
          label={t('filter.sort.nameAsc')}
        />
        <Radio
          name="sort"
          onChange={handleChange}
          selectedValue={filters.sort}
          value="price:asc"
          label={t('filter.sort.priceAsc')}
        />
        <Radio
          name="sort"
          onChange={handleChange}
          selectedValue={filters.sort}
          value="price:desc"
          label={t('filter.sort.priceDesc')}
        />
      </div>
    </FilterSection>
  );
}

export default FilterSectionSort;
